import { action } from '@ember/object';
import type Owner from '@ember/owner';

import $ from 'jquery';

import type { PopupData } from 'webapp-types';

import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';
import type { Args } from 'webapp/components/popup/inner/context';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

export interface Option {
	id: string | number;
	hex: string;
	name?: string;
	selected?: boolean;
	disabled?: boolean;
}

export default class CommonPopupColorPickerComponent extends PopupInnerContextComponent<PopupData.Common.ColorPicker> {
	colpickJqEl: JQuery<HTMLElement> | null = null;

	hasHash = false;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.hasHash = this.popupData.value?.startsWith('#');

		this.args.model.on('outside-color-change', this, (color) => {
			this.colpickJqEl?.colpickSetColor(color as string);
		});
	}

	get hasSubmit() {
		return !!this.popupData.hasSubmit;
	}

	change(value: string, close = false): void {
		const formattedValue = this.hasHash ? `#${value}` : value;

		this.popupData.onChange(formattedValue);

		if (close) {
			this.close();
		}
	}

	@action
	setupView(node: HTMLElement) {
		const jqEl = $(node);

		const hasSubmit = this.hasSubmit;

		jqEl.colpick({
			flat: true,
			layout: 'hex',
			submit: hasSubmit,
			colorScheme: this.args.model.theme,
			color: this.popupData.value,
			onChange: (
				_hsb: unknown,
				hex: string,
				_rgb: unknown,
				_el: HTMLElement,
				bySetColor: number,
			) => {
				if (!bySetColor && !hasSubmit) {
					this.change(hex);
				}
			},
			onSubmit: (
				_hsb: unknown,
				hex: string,
				_rgb: unknown,
				_el: HTMLElement,
				bySetColor: number,
			) => {
				if (!bySetColor && hasSubmit) {
					this.change(hex, true);
				}
			},
		});

		this.colpickJqEl = jqEl;
	}

	@action
	teardownView() {
		const el = this.colpickJqEl;
		if (el?.length) {
			el.colpickDestroy();
		}
	}
	<template>
		<div {{didInsert this.setupView}} {{willDestroy this.teardownView}}></div>
	</template>
}
